import { authenticator } from 'otplib';
import { decryptSecret } from './cryptoService';

export const generateTOTP = (encryptedSecret: string, backupPassword: string): string => {
  try {
    const secret = decryptSecret(encryptedSecret, backupPassword);
    return authenticator.generate(secret);
  } catch (error) {
    return 'Error';
  }
};

export const generateQRCode = (secret: string, name: string, issuer: string = 'Vaultal'): string => {
  const otpauth = authenticator.keyuri(name, issuer, secret);
  return otpauth;
}; 